module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container Paymentdetails2Index"
  }, [_c('h1', {
    staticClass: "m-label"
  }, [_vm._v("paymentdetails2情報")]), _vm._v(" "), (_vm.paymentdetails2.id !== _vm.edit_id.edit_id) ? [_c('div', {
    staticClass: "index-box"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": "row wrap"
    }
  }, [_c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.id))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("契約日")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.contract.contract_date))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("解約種類")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.contract.cancel_type))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("営業所")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.contract.office))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("作成日")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.created_at.substring(0, 10)))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("更新日")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.updated_at.substring(0, 10)))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('btn', {
    staticStyle: {
      "margin-top": "1rem !important"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deletePaymentdetails2(_vm.paymentdetails2)
      }
    }
  }, [_vm._v("削除")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.edit(_vm.paymentdetails2)
      }
    }
  }, [_vm._v("編集")])], 1)] : _vm._e(), _vm._v(" "), (_vm.paymentdetails2.id == _vm.edit_id.edit_id) ? [_c('div', {
    staticClass: "index-box"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": "row wrap"
    }
  }, [_c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.id))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("契約日")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.contract.contract_date))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("解約種類")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.contract.cancel_type))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("営業所")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.contract.office))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("作成日")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.created_at.substring(0, 10)))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "th"
  }, [_vm._v("更新日")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.paymentdetails2.updated_at.substring(0, 10)))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('btn', {
    staticStyle: {
      "margin-top": "1rem !important"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelPaymentdetails2(_vm.paymentdetails2)
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.patchPaymentdetails2(_vm.paymentdetails2)
      }
    }
  }, [_vm._v("更新")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ff4de0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Paymentdetails2/Paymentdetails2Index.vue
// module id = 1431
// module chunks = 0